const map = {
	"./ax.png": 3581,
	"./b2b.png": 5562,
	"./bc.png": 9227,
	"./bigcommerce.png": 3603,
	"./crm.png": 9640,
	"./ege.png": 593,
	"./f&o.png": 6391,
	"./gp.png": 2807,
	"./imagerelay.png": 9536,
	"./magento.png": 5667,
	"./marketplace.png": 6969,
	"./nav.png": 4479,
	"./netsuite.png": 1045,
	"./oms.png": 587,
	"./pimcore.png": 3175,
	"./sage.png": 1050,
	"./sap.png": 2600,
	"./sfcc.png": 2403,
	"./shopify.png": 1174
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5476;